/* ============================================================
   product-buybox.js — Muyu PDP satın-alma çekirdeği (vanilla, defer)
   Beden seçici + price-engine (taksit /6 + HAVALE %15 görsel) +
   hediye seçici + AJAX add-to-cart + mobil sticky CTA.

   İŞ MANTIĞI (BİREBİR — BUILD-PLAN §3):
     • taksit  = Math.round(price / 6)
     • havale  = (Math.floor(Math.round(price * 85 / 100) / 100) * 100)   (SADECE görsel, sepete UYGULANMAZ)
     • para format = Math.round(cents/100).toLocaleString('tr-TR') + ' TL'
                      (price-format.liquid ile tutarlı)
     • hediye paketi = yatak ENİNDEN (cart-v2.js syncMattress ile aynı kural):
       en ≥180 → king · en ≥140 → double · altı → single (220/240 dahil)
     • properties[Hediye] değeri TAM 'Uyku Seti' (tek hediye seçeneği)
     • localStorage('muyu_gift') ile hediye seçimi kalıcı
     • başarıda window.openCartDrawer?.() (guarded) yoksa .cart-count artır

   Tek root: [data-buybox]. Hiçbir global bırakmaz (sticky requestSubmit hariç).
   ============================================================ */
(function () {
  'use strict';

  /* Hediye paketi ölçü sınıfı: sabit liste DEĞİL, en eşiği (cart-v2.js ile aynı).
     14 Eki: /^(180|200)/ listesi 220x200 ve 240x200'ü 'single' sayıp Tek yorgan +
     1 yastık ekliyordu → Bxgy 'Uyku Seti Double 2026' eşleşmiyor, hediye PARALI geliyordu. */
  var DOUBLE_MIN_WIDTH = 140;
  var KING_MIN_WIDTH = 180;
  /* Tek geçerli hediye anahtarı. BON+BON hediye olmaktan çıktı (18 Ağu) → burada
     kasten YOK: eski oturumların localStorage('muyu_gift')='bonbon' değeri bu
     haritadan geçemez, seçim Uyku Seti'nde kalır. */
  var GIFT_VALUES = { 'uyku-seti': 'Uyku Seti' };

  function formatMoney(cents) {
    return Math.round(cents / 100).toLocaleString('tr-TR') + ' TL';
  }

  function formatStickyMoney(cents) {
    return Math.round(cents / 100).toLocaleString('tr-TR') + ' TL';
  }

  function vibrate(ms) {
    if (navigator.vibrate) navigator.vibrate(ms);
  }

  /* ── Dinamik ödeme tablosu ── */
  var INSTALLMENTS = [
    { n: 1, label: 'Tek Çekim' },
    { n: 2, label: '2 Taksit'  },
    { n: 3, label: '3 Taksit'  },
    { n: 6, label: '6 Taksit'  },
  ];

  function makeEl(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text !== undefined) el.textContent = text;
    return el;
  }

  function makeSectionHead(title, badgeText, mod) {
    var head = makeEl('div', 'pay-table__section-head' + (mod ? ' pay-table__section-head--' + mod : ''));
    head.appendChild(makeEl('span', null, title));
    head.appendChild(makeEl('span', 'pay-table__badge' + (mod ? ' pay-table__badge--' + mod : ''), badgeText));
    return head;
  }

  function renderPaymentTable(el, cents) {
    if (!el) return;
    var havale = (Math.floor(Math.round(cents * 85 / 100) / 100) * 100);
    var table = makeEl('div', 'pay-table');

    /* ── Kredi kartı ── */
    table.appendChild(makeSectionHead('Kredi Kartı', 'Vade Farkı Yok', null));

    INSTALLMENTS.forEach(function (inst, i) {
      var amount = Math.round(cents / inst.n);
      var row = makeEl('div', 'pay-table__row ' + (i % 2 === 0 ? 'pay-table__row--odd' : 'pay-table__row--even'));
      row.appendChild(makeEl('span', 'pay-table__label', inst.label));
      var amt = makeEl('span', 'pay-table__amount');
      if (inst.n === 1) {
        amt.textContent = formatMoney(amount);
      } else {
        amt.appendChild(makeEl('strong', null, formatMoney(amount)));
        amt.appendChild(document.createTextNode(' × ' + inst.n));
      }
      row.appendChild(amt);
      table.appendChild(row);
    });

    /* ── Havale / EFT ── */
    table.appendChild(makeSectionHead('Havale / EFT', '%15 İndirim', 'havale'));

    var havaleRow = makeEl('div', 'pay-table__row pay-table__row--havale');
    havaleRow.appendChild(makeEl('span', 'pay-table__label', 'Toplam'));

    var amtWrap = makeEl('span', 'pay-table__amount pay-table__amount--havale');
    amtWrap.appendChild(makeEl('span', 'pay-table__original', formatMoney(cents)));
    amtWrap.appendChild(document.createTextNode(formatMoney(havale)));
    havaleRow.appendChild(amtWrap);
    table.appendChild(havaleRow);

    el.textContent = '';
    el.appendChild(table);
  }

  function initBuybox(root) {
    var jsonEl = root.querySelector('[data-variant-json]') || document.querySelector('[data-variant-json]');
    var giftJsonEl = root.querySelector('[data-gift-json]') || document.querySelector('[data-gift-json]');
    var variants = [];
    var giftConfig = null;
    if (jsonEl) {
      try { variants = JSON.parse(jsonEl.textContent || '[]'); } catch (e) { console.error('buybox: variant JSON parse failed', e); }
    }
    if (giftJsonEl) {
      try { giftConfig = JSON.parse(giftJsonEl.textContent || 'null'); } catch (e) { console.error('buybox: gift JSON parse failed', e); }
    }

    var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-size-btn]'));
    /* Chip içine ölçü kategorisi (Tek/Çift/King) alt-etiketi eklendi → btn.textContent
       artık "90x190Çift Kişilik" döner. Ölçüyü temiz almak için data-size öncelikli. */
    function sizeOf(el) {
      if (!el) return '';
      return (el.getAttribute('data-size') || el.textContent || '').trim();
    }
    var variantInput = root.querySelector('[data-variant-id]');
    var giftInput = root.querySelector('[data-gift-input]');
    var addBtn = root.querySelector('[data-add-btn]');
    var form = root.querySelector('[data-product-form]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyDec = root.querySelector('[data-qty-dec]');
    var qtyInc = root.querySelector('[data-qty-inc]');
    if (qtyDec && qtyInput) {
      qtyDec.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
    }
    if (qtyInc && qtyInput) {
      qtyInc.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v < 99) qtyInput.value = v + 1;
      });
    }

    /* Ödeme tablosu */
    var paymentTableEl = root.querySelector('[data-payment-table]');

    /* Price block (recompute targets) */
    var priceEl = root.querySelector('[data-price-current]');
    var compareEl = root.querySelector('[data-price-compare]');
    var installmentEl = root.querySelector('[data-price-installment]');
    var havaleEl = root.querySelector('[data-price-havale]');
    var priceSizeEl = root.querySelector('[data-price-size]');

    /* Sticky CTA targets */
    var stickyCta = root.querySelector('[data-sticky-cta]') || document.querySelector('[data-sticky-cta]');
    var stickyPrice = stickyCta ? stickyCta.querySelector('[data-sticky-price]') : null;
    var stickySize = stickyCta ? stickyCta.querySelector('[data-sticky-size]') : null;
    var stickyHavale = stickyCta ? stickyCta.querySelector('[data-sticky-havale]') : null;
    var stickyGift = stickyCta ? stickyCta.querySelector('[data-sticky-gift]') : null;
    var stickyAdd = stickyCta ? stickyCta.querySelector('[data-sticky-add]') : null;
    var stickySizeValue = stickyCta ? stickyCta.querySelector('[data-sticky-size-value]') : null;
    var stickyGiftValue = stickyCta ? stickyCta.querySelector('[data-sticky-gift-value]') : null;
    var stickySizeToggle = stickyCta ? stickyCta.querySelector('[data-sticky-size-toggle]') : null;
    var stickyGiftToggle = stickyCta ? stickyCta.querySelector('[data-sticky-gift-toggle]') : null;
    var stickySizeMenu = stickyCta ? stickyCta.querySelector('[data-sticky-size-menu]') : null;
    var stickySizeOptions = stickyCta ? Array.prototype.slice.call(stickyCta.querySelectorAll('[data-sticky-size-option]')) : [];
    var stickyTitlePrefix = stickyCta ? (stickyCta.getAttribute('data-title-prefix') || '') : '';

    /* position:fixed GÜVENLİĞİ — child ref'leri yukarıda yakalandı, artık taşıyabiliriz.
       Bir üst element'te transform/filter/will-change/contain varsa (Android webview'de
       sık), fixed viewport yerine o ata'ya göre konumlanır → sticky CTA sayfa ORTASINA
       düşer. Body'nin DOĞRUDAN çocuğu yapınca viewport'a (bottom:0) kilitlenir, hiçbir
       ata bozamaz. JS event'leri ref ile bağlı → taşıma davranışı etkilemez. */
    if (stickyCta && stickyCta.parentNode !== document.body) {
      document.body.appendChild(stickyCta);
    }

    var selectedGiftKey = 'uyku-seti';
    var selectedSizeText = '';
    var selectedGiftSizeMode = 'single';

    /* ── Beden seçici (§3.4) ── */
    function findVariant(id) {
      id = parseInt(id, 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    function getGiftSizeMode(sizeText) {
      var wm = String(sizeText || '').match(/(\d{2,3})/);
      var w = wm ? parseInt(wm[1], 10) : 0;
      if (w >= KING_MIN_WIDTH) return 'king';
      if (w >= DOUBLE_MIN_WIDTH) return 'double';
      return 'single';
    }

    function updateGiftQty(mode) {
      root.querySelectorAll('[data-gift-qty]').forEach(function (qty) {
        var label = qty.getAttribute('data-' + mode + '-label') || qty.getAttribute('data-single-label');
        var price = qty.getAttribute('data-' + mode + '-price') || qty.getAttribute('data-single-price');
        qty.textContent = label;
        var giftCardEl = qty.closest('.gift-card');
        var priceEl = giftCardEl && giftCardEl.querySelector('[data-gift-price]');
        if (priceEl) priceEl.textContent = formatMoney(parseInt(price, 10));
      });
    }

    function selectSize(btn) {
      if (btn.classList.contains('is-unavailable') || btn.disabled) return;

      sizeBtns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      var variantId = btn.getAttribute('data-variant-id');
      var price = parseInt(btn.getAttribute('data-price'), 10);
      var compare = parseInt(btn.getAttribute('data-compare-price'), 10) || 0;
      var sizeText = sizeOf(btn);
      var giftSizeMode = getGiftSizeMode(sizeText);
      selectedSizeText = sizeText;
      selectedGiftSizeMode = giftSizeMode;

      if (variantInput) variantInput.value = variantId;
      vibrate(10);

      /* Price engine recompute */
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (compareEl) {
        if (compare > price) {
          compareEl.textContent = formatMoney(compare);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (installmentEl) {
        installmentEl.innerHTML = '6 x <strong>' + formatMoney(Math.round(price / 6)) + '</strong> vade farksız taksitle!';
      }
      var havale = (Math.floor(Math.round(price * 85 / 100) / 100) * 100);
      if (havaleEl) {
        havaleEl.innerHTML = 'Havale ile <strong>' + formatMoney(havale) + '</strong> <span class="price-havale-badge">Peşin indirimli</span>';
      }
      if (priceSizeEl) priceSizeEl.textContent = sizeText;

      /* Ödeme tablosu güncelle */
      renderPaymentTable(paymentTableEl, price);

      /* Hediye paketi tek/çift/king */
      updateGiftQty(giftSizeMode);

      /* Sticky özeti */
      if (stickyPrice) stickyPrice.textContent = formatStickyMoney(price);
      if (stickySize) stickySize.textContent = stickyTitlePrefix + sizeText;
      if (stickyHavale) stickyHavale.textContent = 'Nakit ' + formatStickyMoney(havale);
      if (stickySizeValue) stickySizeValue.textContent = sizeText;
      stickySizeOptions.forEach(function (option) {
        option.classList.toggle('is-active', option.getAttribute('data-sticky-size-option') === variantId);
      });

      /* Sold-out state — tıklanan beden zaten is-unavailable guard'ından geçti (= mevcut).
         Fail-open: variant ancak AÇIKÇA available:false ise Tükendi; bulunamazsa CTA açık kalır. */
      var variant = findVariant(variantId);
      var soldOut = !!variant && variant.available === false;
      if (addBtn) {
        addBtn.disabled = soldOut;
        addBtn.textContent = soldOut
          ? (addBtn.getAttribute('data-label-soldout') || 'Tükendi')
          : (addBtn.getAttribute('data-label-add') || 'Sepete Ekle');
      }

      /* Deep-link ?variant=ID */
      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url);
      } catch (e) { /* noop */ }
    }

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { selectSize(btn); });
    });

    function scrollStickyTarget(target) {
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var focusable = target.matches('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        ? target
        : target.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable && typeof focusable.focus === 'function') {
        setTimeout(function () { focusable.focus({ preventScroll: true }); }, 350);
      }
    }

    function closeStickyMenus(exceptMenu) {
      [
        { menu: stickySizeMenu, toggle: stickySizeToggle }
      ].forEach(function (item) {
        if (!item.menu || item.menu === exceptMenu) return;
        item.menu.hidden = true;
        if (item.toggle) item.toggle.setAttribute('aria-expanded', 'false');
      });
    }

    function toggleStickyMenu(menu, toggle) {
      if (!menu || !toggle) return;
      var willOpen = menu.hidden;
      closeStickyMenus(menu);
      menu.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }

    if (stickySizeToggle) {
      stickySizeToggle.addEventListener('click', function (event) {
        event.preventDefault();
        scrollStickyTarget(root.querySelector('[data-variant-picker]') || root.querySelector('[data-size-btn]'));
      });
    }

    stickySizeOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var selectedId = option.getAttribute('data-sticky-size-option');
        var target = sizeBtns.find(function (btn) {
          return btn.getAttribute('data-variant-id') === selectedId;
        });
        if (target) selectSize(target);
        closeStickyMenus();
      });
    });

    /* Ödeme tablosu ilk render — data-price Liquid'den geliyor */
    if (paymentTableEl) {
      var initPrice = parseInt(paymentTableEl.getAttribute('data-price'), 10);
      if (initPrice > 0) renderPaymentTable(paymentTableEl, initPrice);
    }

    /* Init gift qty from active size */
    var activeSize = root.querySelector('[data-size-btn].is-active');
    if (activeSize) updateGiftQty(getGiftSizeMode(sizeOf(activeSize)));
    if (activeSize) {
      selectedSizeText = sizeOf(activeSize);
      selectedGiftSizeMode = getGiftSizeMode(selectedSizeText);
    }

    /* ── Hediye seçici (§3.5) ── */
    var giftCards = Array.prototype.slice.call(root.querySelectorAll('[data-gift-card]'));

    function applyGift(giftKey, persist) {
      selectedGiftKey = giftKey;
      giftCards.forEach(function (c) {
        var on = c.getAttribute('data-gift') === giftKey;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var label = GIFT_VALUES[giftKey] || giftKey;
      if (giftInput) giftInput.value = label;
      if (stickyGift) stickyGift.textContent = '+ ' + label;
      if (stickyGiftValue) stickyGiftValue.textContent = '+ ' + label;
      if (persist) {
        try { localStorage.setItem('muyu_gift', giftKey); } catch (e) { /* noop */ }
      }
    }

    var savedGift = null;
    try { savedGift = localStorage.getItem('muyu_gift'); } catch (e) { /* noop */ }
    if (savedGift && GIFT_VALUES[savedGift]) {
      applyGift(savedGift, false);
    }

    giftCards.forEach(function (card) {
      card.addEventListener('click', function () {
        applyGift(card.getAttribute('data-gift'), true);
        vibrate(10);
        /* 19 Eki: kart tıklaması artık lead formu AÇMAZ (açanların yalnız %12'si
           sepete ekliyordu). Bunun yerine hediye detayı (kartın "i" tetiği,
           data-gift-modal) açılır. "i" kendi listener'ında stopPropagation
           çağırdığı için bu programatik tık karta geri dönmez. Lead formu
           yalnız sepete ekleme SONRASI (B yolu, context:'cart') açılır. */
        try {
          var info = card.querySelector('[data-gift-modal]');
          if (info) info.click();
        } catch (e) {
          console.error('buybox: gift info modal (card) failed', e);
        }
      });
    });

    if (stickyGiftToggle) {
      stickyGiftToggle.addEventListener('click', function (event) {
        event.preventDefault();
        scrollStickyTarget(root.querySelector('[data-gift-picker]') || root.querySelector('[data-gift-card]'));
      });
    }

    /* Hediye içeriği metni — tek paket (Uyku Seti) olduğundan yalnız ölçü moduna bakar. */
    function giftContents(mode) {
      if (mode === 'king') return '2 Yastık + King Yorgan';
      if (mode === 'double') return '2 Yastık + Çift Kişilik Yorgan';
      return '1 Yastık + Tek Kişilik Yorgan';
    }

    function buildGiftItems(parentVariantId, parentQty) {
      if (!giftConfig || !giftConfig.enabled) return [];
      var giftKey = selectedGiftKey || 'uyku-seti';
      var label = GIFT_VALUES[giftKey] || 'Uyku Seti';
      var mode = selectedGiftSizeMode || 'single';
      var baseProps = {
        '_gift': 'true',
        '_parent_variant': String(parentVariantId),
        '_gift_type': giftKey,
        '_gift_label': label,
        '_gift_contents': giftContents(mode),
        '_gift_size': selectedSizeText || ''
      };

      var duvetVariantId = mode === 'king'
        ? giftConfig.duvetKingVariantId
        : (mode === 'double' ? giftConfig.duvetDoubleVariantId : giftConfig.duvetSingleVariantId);
      var sleepSetItems = [];
      if (giftConfig.microgelVariantId) {
        sleepSetItems.push({
          id: parseInt(giftConfig.microgelVariantId, 10),
          quantity: (mode === 'single' ? 1 : 2) * parentQty,
          properties: Object.assign({}, baseProps, { '_gift_component': 'microgel-yastik' })
        });
      }
      if (duvetVariantId) {
        sleepSetItems.push({
          id: parseInt(duvetVariantId, 10),
          quantity: parentQty,
          properties: Object.assign({}, baseProps, { '_gift_component': 'yorgan' })
        });
      }
      return sleepSetItems;
    }

    if (stickyCta) {
      document.addEventListener('click', function (event) {
        if (stickyCta.contains(event.target)) return;
        closeStickyMenus();
      });
    }

    /* ── Karyola bilgi kartı (The Original Bed cross-sell) — tek-tık ekleme YOK; kart → detay popup → ürün sayfası ── */
    var karyolaWrap = root.querySelector('[data-karyola-attach]');
    var karyolaCard = root.querySelector('[data-karyola-card]');
    var karyolaJsonEl = root.querySelector('[data-karyola-json]');
    var karyolaPriceEl = karyolaCard ? karyolaCard.querySelector('[data-karyola-price]') : null;
    var karyolaCompareEl = karyolaCard ? karyolaCard.querySelector('[data-karyola-compare]') : null;
    var karyolaDiscPct = karyolaWrap ? (parseFloat(karyolaWrap.getAttribute('data-karyola-discount')) || 0) : 0;
    var karyolaSizeEl = karyolaCard ? karyolaCard.querySelector('[data-karyola-size]') : null;
    var karyolaVariants = null;
    var karyolaMatch = null;
    if (karyolaJsonEl) {
      try { karyolaVariants = JSON.parse(karyolaJsonEl.textContent || 'null'); } catch (e) { console.error('buybox: karyola JSON parse failed', e); }
    }
    function normKaryolaSize(t) {
      return String(t || '').toLowerCase().replace(/\s+/g, '').replace(/\u00d7/g, 'x').replace(/cm/g, '');
    }
    var KARYOLA_SIZE_MAP = { '90x190': '90x200' };
    function updateKaryola(sizeText) {
      if (!karyolaWrap || !karyolaVariants || !karyolaVariants.length) return;
      var key = normKaryolaSize(sizeText);
      var mappedKey = KARYOLA_SIZE_MAP[key] || key;
      karyolaMatch = null;
      for (var ki = 0; ki < karyolaVariants.length; ki++) {
        if (karyolaVariants[ki].available && normKaryolaSize(karyolaVariants[ki].title) === mappedKey) { karyolaMatch = karyolaVariants[ki]; break; }
      }
      if (!karyolaMatch) {
        karyolaWrap.hidden = true;
        return;
      }
      karyolaWrap.hidden = false;
      /* Yatakla-birlikte kampanyası: gösterim indirimli, tahsilat Shopify otomatik indirimiyle birebir */
      var kDiscPrice = karyolaDiscPct > 0 ? Math.round(karyolaMatch.price * (100 - karyolaDiscPct) / 100) : karyolaMatch.price;
      if (karyolaPriceEl) karyolaPriceEl.textContent = '+' + formatStickyMoney(kDiscPrice);
      if (karyolaCompareEl) {
        if (kDiscPrice !== karyolaMatch.price) {
          karyolaCompareEl.textContent = formatStickyMoney(karyolaMatch.price);
          karyolaCompareEl.hidden = false;
        } else {
          karyolaCompareEl.hidden = true;
        }
      }
      var karyolaSaveEl = karyolaCard ? karyolaCard.querySelector('[data-karyola-save]') : null;
      if (karyolaSaveEl) {
        if (kDiscPrice !== karyolaMatch.price) {
          karyolaSaveEl.textContent = 'Yatakla birlikte %' + karyolaDiscPct + ' indirimli — ' + formatStickyMoney(karyolaMatch.price - kDiscPrice) + ' kazanç';
          karyolaSaveEl.hidden = false;
        } else {
          karyolaSaveEl.hidden = true;
        }
      }
      var kmRoot = document.querySelector('[data-karyola-modal]');
      if (kmRoot) kmRoot.setAttribute('data-km-pdp-variant', String(karyolaMatch.id));
      var kmSize = document.querySelector('[data-km-size]');
      var kmPrice = document.querySelector('[data-km-price]');
      var kmCompare = document.querySelector('[data-km-compare]');
      if (kmSize) kmSize.textContent = String(karyolaMatch.title).trim() + ' karyola';
      if (kmPrice) kmPrice.textContent = '+' + formatStickyMoney(kDiscPrice);
      if (kmCompare) {
        if (kDiscPrice !== karyolaMatch.price) {
          kmCompare.textContent = formatStickyMoney(karyolaMatch.price);
          kmCompare.hidden = false;
        } else {
          kmCompare.hidden = true;
        }
      }
    }
    function openKaryolaModal() {
      var kmEl = document.querySelector('[data-karyola-modal]');
      if (!kmEl) return;
      /* KÖK KURAL: scroll-lock YOK — hapis CSS'te (karyola-detail-modal.liquid). */
      kmEl.hidden = false;
      kmEl.dispatchEvent(new CustomEvent('km:open'));
    }
    if (karyolaCard) {
      karyolaCard.addEventListener('click', function (e) {
        if (e.target && e.target.closest && (e.target.closest('a') || e.target.closest('[data-karyola-detail]'))) { return; }
        openKaryolaModal();
        vibrate(10);
      });
      karyolaCard.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); openKaryolaModal(); }
      });
    }
    if (karyolaWrap) {
      root.addEventListener('click', function (e) {
        var kBtn = e.target && e.target.closest ? e.target.closest('[data-size-btn]') : null;
        if (kBtn) { updateKaryola(kBtn.getAttribute('data-size')); return; }
        var kOpt = e.target && e.target.closest ? e.target.closest('[data-sticky-size-option]') : null;
        if (kOpt) {
          var kVid = kOpt.getAttribute('data-sticky-size-option');
          var kMatchBtn = sizeBtns.find(function (b) { return b.getAttribute('data-variant-id') === kVid; });
          if (kMatchBtn) updateKaryola(kMatchBtn.getAttribute('data-size'));
        }
      });
      if (activeSize) updateKaryola(sizeOf(activeSize));
    }
    /* ── Add to cart (AJAX §3.6) ── */
    function addToCart() {
      if (!addBtn || addBtn.disabled) return;
      var id = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!id) return;

      var original = addBtn.getAttribute('data-label-add') || 'Sepete Ekle';
      addBtn.disabled = true;
      addBtn.textContent = 'Ekleniyor...';
      addBtn.classList.add('is-bounce');
      vibrate(15);
      setTimeout(function () { addBtn.classList.remove('is-bounce'); }, 400);

      var routes = window.routes || {};
      var cartAddUrl = routes.cart_add_url || '/cart/add';
      /* Sepete yönlendirme TEK kapıdan geçer: hediye lead modali açılırsa
         yönlendirme modal kapanana kadar ertelenir, açılamazsa eski akış aynen
         işler. İki kez tetiklenmez. */
      var cartRedirected = false;
      function goToCart() {
        if (cartRedirected) return;
        cartRedirected = true;
        window.location.href = (routes.cart_url || '/cart');
      }
      var parentQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var items = [Object.assign({
        id: id,
        quantity: parentQty
      }, giftInput ? { properties: { 'Hediye': giftInput.value || 'Uyku Seti' } } : {})].concat(buildGiftItems(id, parentQty));

      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data && (data.description || data.message) || 'Sepete eklenemedi');
            return data;
          });
        })
        .then(function () {
          var giftItem = items.find(function (item) {
            return item.properties && item.properties._gift === 'true';
          });
          if (giftItem) {
            document.documentElement.dispatchEvent(new CustomEvent('gift:added', {
              detail: {
                variantId: giftItem.id,
                giftType: giftItem.properties._gift_type,
                parentVariantId: id
              }
            }));
          }
          addBtn.textContent = 'Eklendi ✓';

          /* ── Hediye lead modali · B yolu: SEPETE EKLEME BAŞARISI (19 Ağu) ──
             Modal SEPETE EKLEMEYE bağlı ve yalnız EKLEME BAŞARILI olduktan SONRA
             açılır. Yalnız hediye DÜŞEN eklemede (giftItem var) — yastık/aksesuar
             eklemesinde açılmaz. Kart tıklamalı A yolu için yukarıya bak;
             bir-kez kilidi (muyu_gift_lead_seen) YALNIZ bu otomatik yolda işler.
             D5 (siparişi öldürme): popup ön koşul DEĞİL. try/catch + boolean dönüş;
             açılmazsa 300 ms'lik eski yönlendirme aynen koşar. Açılırsa yarış olmasın
             diye yönlendirme modal kapanışına (X / ESC / dış tık / "Hediye istemiyorum")
             bağlanır — her kapanış yolu sepete götürür. */
          var leadOpened = false;
          if (giftItem) {
            try {
              leadOpened = !!(window.MuyuGiftLead && window.MuyuGiftLead.open && window.MuyuGiftLead.open({
                context: 'cart',
                parentVariantId: id,
                onClose: goToCart
              }));
            } catch (e) {
              console.error('buybox: gift lead modal failed', e);
              leadOpened = false;
            }
          }
          if (!leadOpened) setTimeout(goToCart, 300);
        })
        .catch(function (err) {
          console.error('buybox: cart/add failed', err);
          addBtn.textContent = 'Hata!';
          setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2000);
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    }
    if (addBtn && !form) {
      addBtn.addEventListener('click', addToCart);
    }

    /* ── Sticky CTA (§3.8) ── */
    if (stickyCta && addBtn) {
      var stickyEnabled = false;
      var scrollScheduled = false;
      /* rAF-throttle: getBoundingClientRect okuması scroll frame'inde layout
         thrashing yapmasın — davranış (görünürlük eşikleri) BİREBİR korunur. */
      var applyStickyState = function () {
        scrollScheduled = false;
        var rect = addBtn.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyEnabled = true;
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        } else if (stickyEnabled && rect.top < window.innerHeight) {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      };
      var onScroll = function () {
        if (scrollScheduled) return;
        scrollScheduled = true;
        window.requestAnimationFrame(applyStickyState);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.requestAnimationFrame(applyStickyState);

      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          if (form && form.requestSubmit) form.requestSubmit();
          else addToCart();
        });
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-buybox]').forEach(initBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Taksit tablosu popup — price-block "Taksit tablosu" linki açar.
   İçerik accordion'daki render edilmiş [data-payment-table]'dan
   HER açılışta klonlanır (seçili ölçüye göre güncel). Global, tek bind.
   ============================================================ */
(function () {
  'use strict';
  if (window.__muyuPayModal) return;
  window.__muyuPayModal = true;

  function start() {
    var modal = document.querySelector('[data-payment-modal]');
    if (!modal) return;
    var body = modal.querySelector('[data-payment-modal-body]');
    var lastFocus = null;

    function open() {
      var src = document.querySelector('[data-payment-table]');
      if (src && body) body.innerHTML = src.innerHTML;
      lastFocus = document.activeElement;
      /* KÖK KURAL: body/html ASLA kilitlenmez. Hapis CSS'te:
         .pay-modal__backdrop touch-action:none + .pay-modal__dialog overscroll:contain. */
      modal.hidden = false;
      var c = modal.querySelector('[data-payment-modal-close]:not([tabindex="-1"])');
      if (c) c.focus();
    }
    function close() {
      modal.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    /* Eski sürüm artığı: cache'teki eski JS html'i kilitli bırakmış olabilir. */
    if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = '';

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-payment-modal-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-payment-modal-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();




/* cdn-tazeleme 19 Agu 11:25 UTC — 5 saatlik bayat edge kaydini kirmak icin surum notu */

